import React, { Component } from 'react'
import classnames from 'classnames'
import Form from 'components/Header/Search/Form'
import Results from 'components/Header/Search/Results'
import PropTypes from 'prop-types'
// import base64 from 'base-64'

import './search.css'

class Search extends Component {
  render () {
    const results = this.props.results
    const meta = this.props.meta

    let title
    let menu = this.props.menu
    let resultsSection = meta && this.props.loaded ? (
      <h3 className='search__empty'>"{meta.terms}" doesn't match anything.</h3>
    ) : false

    if (results && results.length > 0) {
      const label = results.length === 1 ? 'Result' : 'Results'
      title = (
        <div className='search__count'>
          <span>{results.length} {label}</span>
          <span className='text--gray-light'> for {meta.terms}</span>
        </div>
      )

      resultsSection = (
        <Results results={results} onNav={this.props.onNav} />
      )

      menu = false
    }

    return (
      <div ref={search => { this.wrapper = search }} className={classnames({
        'search': true,
        'search--show': this.props.visible
      })}>
        <div className='container-fluid'>
          <div className='search__inner'>
            <Form
              searchString={this.props.term}
              onSubmit={this.props.submitHandler}
              onInputChange={this.props.onInputChange}
              placeholder='Search...'
            />
            {title}
            {resultsSection}
          </div>
          {menu}
        </div>
      </div>
    )
  }
}

Search.propTypes = {
  visible: PropTypes.bool.isRequired,
  menu: PropTypes.node.isRequired
}

export default Search



// WEBPACK FOOTER //
// ./src/components/Header/Search/index.js